import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 103 100" fill="none" {...props}>
      <title>{props.title || 'Quality'}</title>
      <g xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.5292 57.6729L9 77.8729L24.625 80.9979L30.875 99.7478L47.5 73.3645"
          fill="#BEEBF6"
          fillOpacity="0.5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M86.2199 57.6729L102.749 77.8729L87.124 80.9979L80.874 99.7478L64.249 73.3645"
          fill="#BEEBF6"
          fillOpacity="0.5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M81.1582 26.375L90.6415 51.8449C91.167 53.2174 90.6638 54.7706 89.4332 55.5741L81.1582 60.9907L78.5748 70.5324C78.1908 71.9502 76.8711 72.9092 75.404 72.8366L65.5332 72.3449L57.8373 78.5449C56.6911 79.4659 55.0586 79.4659 53.9123 78.5449L46.2165 72.3324L36.3457 72.8241C34.8785 72.8967 33.5589 71.9377 33.1748 70.5199L30.5915 60.9782L22.3165 55.5616C21.0859 54.7581 20.5826 53.2049 21.1082 51.8324L24.6248 42.6116L21.1082 33.3741C20.573 31.9956 21.0772 30.4307 22.3165 29.6241L30.5915 24.2074L33.1748 14.6657C33.5589 13.2479 34.8785 12.2889 36.3457 12.3616L46.2165 12.8741L53.9123 6.69072C55.0586 5.76976 56.6911 5.76976 57.8373 6.69072L81.1582 26.375Z"
          fill="#BEEBF6"
        />
        <path
          d="M75 21.875L52.2083 44.6667C51.6229 45.2529 50.8285 45.5823 50 45.5823C49.1715 45.5823 48.3771 45.2529 47.7917 44.6667L40.625 37.5"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.6542 54.7979L3.125 74.9979L18.75 78.1229L25 96.8728L41.625 70.4895"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M80.3451 54.7979L96.8743 74.9979L81.2493 78.1229L74.9993 96.8728L58.3743 70.4895"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M81.2497 39.7366L84.7663 48.9699C85.2919 50.3424 84.7886 51.8956 83.558 52.6991L75.283 58.1157L72.6997 67.6574C72.3156 69.0752 70.996 70.0342 69.5288 69.9616L59.658 69.4699L51.9622 75.6699C50.8159 76.5908 49.1834 76.5908 48.0372 75.6699L40.3413 69.4574L30.4705 69.9491C29.0034 70.0217 27.6837 69.0627 27.2997 67.6449L24.7163 58.1032L16.4413 52.6866C15.2107 51.8831 14.7075 50.3299 15.233 48.9574L18.7497 39.7366L15.233 30.4991C14.6978 29.1206 15.2021 27.5557 16.4413 26.7491L24.7163 21.3324L27.2997 11.7907C27.6837 10.3729 29.0034 9.41392 30.4705 9.48655L40.3413 9.99905L48.0372 3.81572C49.1834 2.89476 50.8159 2.89476 51.9622 3.81572L59.658 9.99905"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </Icon>
  )
}
